<div class="title-container">
  <tausi-logo class="mb-3" width="80" imageName="coat"></tausi-logo>

  <h1>The United Republic of Tanzania.</h1>
  <h3>The President's Office</h3>
  <h4>Regional Administration and Local Government</h4>
</div>
